function dateFormatDay(row) {
  if (row) {
    var date = new Date(row); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10 ?
        "0" + (date.getMonth() + 1) :
        date.getMonth() + 1) + "-";
    var D =
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
    return Y + M + D;
  } else {
    return ""
  }
}

export default dateFormatDay;
